export default "__VITE_ASSET__4emMh74i__"